<template>
  <div class="default">
    <Header />
    <portal-target name="popup-gallery"> </portal-target>

    <Cookies />
    <responsive-layout />
    <!-- <Cookies /> -->
  </div>
</template>

<script>
import ResponsiveLayout from "./ResponsiveLayout.vue";
import Header from "@/components/modules/Header";
import Cookies from "@/components/Cookies/Cookies.vue";

export default {
  components: {
    ResponsiveLayout,
    Header,
    Cookies
  }
};
</script>

<style>
.data-scroll-sticky {
  position: absolute;
  /* height: 25000px; */
  width: 100%;
  /* pointer-events: none;
		opacity: 0;
		top: 0;
		left: 0;
		margin-top: 120px;  */
  @media (max-width: 1023px) {
    margin-top: 115px;
  }
}
</style>
